var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PaidMemberRegistrationFinish"},[_c('div',[_c('section-header',{attrs:{"heading":"2","ja":"WEB決済での会員状態を更新しました"}}),_c('div',{staticClass:"description"},[_vm._v("プロフィール設定から会員状態を確認してください。")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }